import React from 'react';
import type { Board } from './PluginHeaderButton.types';

import { PluginHeaderButtons } from './PluginHeaderButtons';
import { renderComponent } from 'app/src/components/ComponentWrapper';

export const renderPluginHeaderButtons = (
  container: Element,
  board: Board,
  openEnabled: () => object,
  openDirectory: () => object,
  openPluginSettings: () => object,
) => {
  if (!container) {
    return;
  }

  return renderComponent(
    React.createElement(PluginHeaderButtons, {
      container,
      board,
      openEnabled,
      openDirectory,
      openPluginSettings,
    }),
    container,
  );
};
